import { SEC_ApiCall, SEC_DataApiPost } from '../func';

function validate(response) {
  if (!response || typeof response !== 'object' || response.message) {
    throw new Error(response?.message || 'Invalid Performance Management administration response');
  }
  return response;
}

export async function getPerformanceManagementAdminData() {
  return validate(await SEC_ApiCall('sysmanager/performance-management'));
}

export async function savePerformanceManagementConfiguration(payload) {
  return validate(await SEC_DataApiPost(
    'sysmanager/performance-management/configuration',
    JSON.stringify(payload),
    {},
  ));
}

export async function updatePerformanceManagerAssignment(payload) {
  return validate(await SEC_DataApiPost(
    'sysmanager/performance-management/manager',
    JSON.stringify(payload),
    {},
  ));
}

export async function updatePerformanceTemplateAssignment(payload) {
  return validate(await SEC_DataApiPost(
    'sysmanager/performance-management/template-access',
    JSON.stringify(payload),
    {},
  ));
}

export async function getPerformanceManagementProgress(profileId) {
  return validate(await SEC_ApiCall('sysmanager/performance-management/progress', { profileId }));
}

/** Permanently remove one Performance Management record as an administrator. */
export async function deletePerformanceManagementRecord(recordId) {
  return validate(await SEC_DataApiPost(
    'sysmanager/performance-management/record/delete',
    JSON.stringify({ recordId }),
    {},
  ));
}
